(() => {
  const money = cents => new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(cents / 100);
  function init(root) {
    if (root.dataset.orderReady || !window.SNFSpecialtyCart) return;
    root.dataset.orderReady = 'true';
    const api = window.SNFSpecialtyCart;
    const width = root.querySelector('[data-width]');
    const height = root.querySelector('[data-height]');
    const quantity = root.querySelector('[data-quantity]');
    const form = root.querySelector('form');
    const button = root.querySelector('[data-specialty-add]');
    const product = JSON.parse(root.querySelector('[data-specialty-product]').textContent);
    const errorBox = root.querySelector('[data-cart-error]');
    let busy = false;
    const colour = () => root.querySelector('.snf-special__colours input:checked');
    const value = () => api.calculate(Number(width.value), Number(height.value), Number(quantity.value));
    const update = () => {
      let price;
      try {
        if (![width, height, quantity].every(input => input.value !== '' && input.checkValidity()) || !colour()) throw new Error(api.config.invalid);
        price = value();
      } catch (_) {}
      button.disabled = busy || !price;
      if (price) root.querySelector('[data-selected-variant]').value = colour().value;
    };
    [width, height, quantity].forEach(input => input.addEventListener('input', update));
    root.querySelectorAll('.snf-special__colours input').forEach(input => input.addEventListener('change', update));
    form.addEventListener('submit', event => { event.preventDefault(); });
    button.addEventListener('click', async event => {
      event.preventDefault();
      if (busy) return;
      let group;
      errorBox.hidden = true;
      try {
        const price = value();
        if (!colour()) throw new Error(api.config.invalid);
        const selected = { id: Number(colour().value), colour: colour().dataset.colour };
        const properties = {};
        root.querySelectorAll('[name^="properties["]').forEach(input => {
          const match = input.name.match(/^properties\[(.*)\]$/);
          if (match && input.value && !match[1].startsWith('_snf_')) properties[match[1]] = input.value;
        });
        if (!Object.entries(properties).some(([key, item]) => key.includes('Special Effect Prints') && !key.startsWith('_') && /^https:\/\//i.test(String(item)))) throw new Error(api.config.artwork);
        busy = true;
        button.textContent = button.dataset.busyLabel;
        update();
        const current = await api.request('products/' + product.handle + '.js');
        const variant = current.variants.find(item => Number(item.id) === selected.id);
        if (!variant || !variant.available) throw new Error(api.config.failed);
        const before = await api.request('cart.js');
        api.verify(before);
        const parts = api.components(price.totalCents - variant.price * price.quantity);
        group = crypto.randomUUID();
        Object.assign(properties, {
          'Finished size': price.width + ' × ' + price.height + ' inches',
          'Transfer quantity': String(price.quantity), 'Colour': selected.colour,
          'Price per transfer': money(price.eachCents) + ' CAD',
          'Calculated transfer total': money(price.totalCents) + ' CAD',
          '_snf_order_group': 'special', '_snf_specialty_group': group, '_snf_specialty_role': 'main',
          '_snf_width': String(price.width), '_snf_height': String(price.height),
          '_snf_pieces': String(price.quantity), '_snf_total': String(price.totalCents)
        });
        const notes = root.querySelector('textarea').value.trim();
        if (notes) properties['Order notes'] = notes;
        await api.request('cart/add.js', { items: [{ id: selected.id, quantity: price.quantity, properties }] });
        const withParent = await api.request('cart.js');
        const parent = withParent.items.find(item => item.properties?._snf_specialty_group === group && item.properties?._snf_specialty_role === 'main');
        if (!parent || parent.quantity !== price.quantity) throw new Error(api.config.failed);
        if (parts.length) await api.request('cart/add.js', { items: parts.map(part => ({ ...part, parent_line_key: parent.key, properties: {
          '_snf_order_group': 'special', '_snf_specialty_group': group, '_snf_specialty_role': 'component',
          'For': product.title + ' — ' + price.quantity + ' transfers, ' + price.width + ' × ' + price.height + ' inches'
        } })) });
        api.verify(await api.request('cart.js'));
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (error) {
        if (group) { try { await api.removeGroup(group); } catch (_) { error = new Error(api.config.mismatch); } }
        errorBox.textContent = error.message || api.config.failed;
        errorBox.hidden = false;
        errorBox.scrollIntoView?.({ block: 'nearest' });
        busy = false;
        button.textContent = button.dataset.label;
        update();
      }
    });
    update();
  }
  const boot = () => document.querySelectorAll('[data-snf-special]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
